<template>

<core-panel>

	<template v-slot:head>

		<h1>On the Cusp</h1>

		<p>Which games are closest to the next h-index level.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in list" :item="{id: item.g}" :count="item.c" v-bind:key="index" :subtext="subtext(item.d)" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'candidates',
			list: []
		}

	},

	methods: {

		setParams: function() {

			return {
				index: this.$route.params.index || ''
			}

		},

		response: function(json) {

			this.list = json.candidates

		},

		subtext: function(value) {

			return 'Last played on ' + this.$options.filters.formatDate(value, this.$util.date.format('Do', 'MMMM', 'YYYY'))

		}

	}

}

</script>